import { render, staticRenderFns } from "./deliveryDetail.vue?vue&type=template&id=0d09e275&scoped=true"
import script from "./deliveryDetail.vue?vue&type=script&lang=js"
export * from "./deliveryDetail.vue?vue&type=script&lang=js"
import style0 from "./deliveryDetail.vue?vue&type=style&index=0&id=0d09e275&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d09e275",
  null
  
)

export default component.exports